module.exports = __webpack_public_path__ + "25822b9616d16c30aff02d54b1929168.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/mystirio.jpg
// module id = 775
// module chunks = 0